import { getBackRoute } from "@shared/navigation/SideNav/helpers/getPageTitle";
import { matchDetailRoute } from "./detailRoutes";
import { splitUrl } from "./viewsModel";

/** More than any detail is nested today (CPE under site, branch under hub); a guard, not a limit. */
const MAX_LEVELS = 4;

/**
 * The list a detail belongs to, for when the detail stops making sense — the partner or
 * customer changed under it (CTX-1281). It follows the SideNav's back route up until it
 * leaves the detail routes, so a nested detail (a branch under its hub, a CPE under its
 * site) lands on the top-level list, not on a parent detail that belongs to the previous
 * customer too. Null when `pathname` is not a detail, or no list is known for it.
 */
export function detailListPath(pathname: string, search = ""): string | null {
  if (!matchDetailRoute(pathname)) return null;
  let path = pathname;
  let query = search;
  for (let level = 0; level < MAX_LEVELS; level++) {
    const back = getBackRoute(path, query);
    if (!back) return null;
    const next = splitUrl(back);
    if (!matchDetailRoute(next.pathname)) return back;
    path = next.pathname;
    query = next.search;
  }
  return null;
}
